import { render } from "./MenuComponent.vue?vue&type=template&id=2bf620dd"
import script from "./MenuComponent.vue?vue&type=script&lang=js"
export * from "./MenuComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/MenuComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bf620dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bf620dd', __exports__)) {
    api.reload('2bf620dd', __exports__)
  }
  
  module.hot.accept("./MenuComponent.vue?vue&type=template&id=2bf620dd", () => {
    api.rerender('2bf620dd', render)
  })

}


export default __exports__